<template>
<v-card>
  <v-card-title v-if='!isSuccess' class='subtitle-1 overline' >
    Reset password
  </v-card-title>
  <v-window v-model="window" >

    <!-- request OTP -->
    <v-window-item >
      <request-status
        :message200="false"
        message404='We were unable to find a user with that email address'
        :request='req' />
      <v-card-text>
        <v-text-field persistent-hint large outlined
          v-model='email'
          label='Your email address'
          hint='Please provide the email address you used to sign up with AppointmentGuru' />
      </v-card-text>
      <v-card-actions >
        <v-btn @click='$emit("back")' text >Back</v-btn>
        <v-spacer ></v-spacer>
        <v-btn @click='getOTP' :loading='req.loading' color='primary' :disabled='!email' >Request reset</v-btn>
      </v-card-actions>
    </v-window-item >


    <!-- Validate OTP -->
    <v-window-item >
      <request-status :message200="false" :request='loginReq' />
      <v-alert text dense tile type='info' border='left' >
        We sent a code to the email address you provided. Please enter that code below to reset your password
      </v-alert>
      <v-card-text>
        <v-text-field persistent-hint large outlined
          v-model='otp'
          label='Login pin'
          hint='Please enter the login pin that we sent to your email address' />
      </v-card-text>
      <v-card-actions >
        <v-btn @click='window--' text >Back</v-btn>
        <v-spacer ></v-spacer>
        <v-btn @click='authOTP' :loading='loginReq.loading' :disabled='!email || !otp || otp.length !== 4' color='primary' >Validate Code</v-btn>
      </v-card-actions>
    </v-window-item >

    <!-- Set password -->
    <v-window-item >
      <request-status :message200="false" :request='req' />
      <v-alert text dense tile type='info' border='left' >
        Thank you <span v-if='user' >{{user.first_name}}</span>.
        We have logged you into your account.
        Please take a moment to reset your password
      </v-alert>

      <v-card-text>
        <h5>Please choose a new password</h5>
        <v-text-field v-model='newpassword1' label='Your new password' type='password' />
        <v-text-field v-model='newpassword2' label='Retype password' type='password' />
      </v-card-text>
      <v-card-actions >
        <v-btn @click='$emit("back")' text >Cancel</v-btn>
        <v-spacer ></v-spacer>
        <v-btn @click='setPassword' color='primary' :disabled='newpassword1.length < 8 || (newpassword1 !== newpassword2)' >Reset Password</v-btn>
      </v-card-actions>
    </v-window-item >

    <!-- SUCCESS -->
    <v-window-item >
      <v-card>
        <v-card-title class='subtitle-1 overline justify-center' >
          You're all set!
        </v-card-title>
        <v-card-text class='text-center' >
          <v-icon color='green' :size='50' >mdi-check-all</v-icon><br/>
          You're logged in, and your new password has been set.
        </v-card-text>
        <v-card-actions >
          <v-btn @click='$emit("done")' color='success' block tile >Done </v-btn>
        </v-card-actions>
      </v-card>
    </v-window-item>

  </v-window>
</v-card>
</template>
<script>
import {AUTH_CLIENT_ID, AUTH_CLIENT_SECRET} from '@/store/constants.js'

const WINDOW = {
  START: 0,
  OTP: 1,
  SET_PASSWORD: 2,
  SUCCESS: 3
}
export default {
  name: 'ResetPassword',
  props: {
    initialEmail: { type: String, required: false }
  },
  data () {
    return {
      window: 0,
      req: {
        method: 'post',
        resource: 'ag.auth'
      },
      loginReq: {
        method: 'post',
        resource: 'auth.login'
      },
      email: '',
      otp: '',
      newpassword1: '',
      newpassword2: '',
    }
  },
  mounted () {
    if (this.initialEmail) { this.email = this.initialEmail }
  },
  methods: {
    getOTP () {
      this.req.extra = 'forgot-password'
      this.req.data = {
        email: this.email,
        method: 'email'
      }
      this.$request('save', this.req)
    },
    authOTP () {
      this.loginReq.data = {
        email: this.email,
        otp: this.otp,
        client_id: AUTH_CLIENT_ID,
        client_secret: AUTH_CLIENT_SECRET
      }
      this.$request('save', this.loginReq)
    },
    setPassword () {
      this.req.extra = 'set-password'
      this.req.data = {
        password: this.newpassword1
      }
      this.$request('save', this.req)
    }
  },
  watch: {
    next () {
      if (this.next === 'auth-otp') { this.window = WINDOW.OTP }
    },
    otp () {
      if (this.otp && this.otp.length === 4) { this.authOTP() }
    },
    token () {
      if (this.token && this.token.length > 10) {
        this.$store.dispatch('auth/logUserIn', this.token)
        this.window = WINDOW.SET_PASSWORD
      }
    },
    requestStatus () {
      if (this.requestStatus === 200) {
        if (this.window === WINDOW.SET_PASSWORD) {
          this.window = WINDOW.SUCCESS
        }
      }
    }
  },
  computed: {
    next () {
      return this.getObjectPath(this.req, 'result.type', null)
    },
    token () {
      return this.getObjectPath(this.loginReq, 'result.access_token', null)
    },
    user () {
      return this.getObjectPath(this.loginReq, 'result.data', null)
    },
    requestStatus () {
      return this.req.status
    },
    isSuccess () {
      return this.window === WINDOW.SUCCESS
    }
  }
}
</script>
